module.exports = __webpack_public_path__ + "fonts/pt_root-ui_regular.724d6c4.woff";